import React, { useState, useRef, useEffect } from 'react';
import { FiEdit } from 'react-icons/fi';

interface EditableAmountCellProps {
  value: number;
  onSave: (amount: number) => void;
  disabled?: boolean;
}

const EditableAmountCell: React.FC<EditableAmountCellProps> = ({ value, onSave, disabled = false }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [editValue, setEditValue] = useState(value.toString());
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (isEditing && inputRef.current) {
      inputRef.current.focus();
      inputRef.current.select();
    }
  }, [isEditing]);

  const handleClick = () => {
    if (!disabled) {
      setIsEditing(true);
      setEditValue(value.toString());
    }
  };

  const handleSave = () => {
    const numValue = parseInt(editValue) || 0;
    onSave(numValue);
    setIsEditing(false);
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      handleSave();
    } else if (e.key === 'Escape') {
      setIsEditing(false);
      setEditValue(value.toString());
    }
  };

  const handleBlur = () => {
    handleSave();
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    // Only allow numbers
    const newValue = e.target.value.replace(/[^0-9]/g, '');
    setEditValue(newValue);
  };

  if (isEditing) {
    return (
      <input
        ref={inputRef}
        type="text"
        value={editValue}
        onChange={handleChange}
        onBlur={handleBlur}
        onKeyDown={handleKeyDown}
        className="editable-amount-input"
      />
    );
  }

  return (
    <span
      className={`editable-amount ${!disabled ? 'clickable' : ''}`}
      onClick={handleClick}
      title="Klicka för att ändra utbetald summa"
    >
      <span>{value} kr</span>
      <FiEdit className="text-gray-400" size={14} />
    </span>
  );
};

export default EditableAmountCell;

